import script from "./EventDetailModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventDetailModal.vue?vue&type=script&lang=ts&setup=true"

import "./EventDetailModal.vue?vue&type=style&index=0&id=1bca550a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bca550a"]])

export default __exports__